import { useEffect, useState } from "react";
import {
	Routes,
	Route,
	Navigate,
	useNavigate,
	useLocation,
} from "react-router-dom";
import NewRegister from "./pages/NovoRegistro";
import { Home } from "./pages/Inicio";
import Login from "./pages/Login";
import { Funcionarios } from "./pages/ListarFuncionarios";
import { Empresas } from "./pages/ListarEmpresas";
import { FuncionariosCadastrar } from "./pages/CadastrarFuncionario";
import { FuncionariosEditar } from "./pages/EditarFuncionario";
import { MeuPGR } from "./pages/Pgr";
import { PgrRiscoEditar } from "./pages/Pgr/RiscoEditar";
import { EmpresasEditar } from "./pages/EditarEmpresa";
import { EmpresasCadastrar } from "./pages/CadastrarEmpresa";
import { Produtos } from "./pages/ListarProdutos";
import { ProdutosCadastrar } from "./pages/CadastrarProduto";
import { ProdutosEditar } from "./pages/EditarProduto";
import { SelecionarPlanos } from "./pages/SelecionarPlanos";
import { Pagamentos } from "./pages/ListarPagamentos";
import { MeusPlanos } from "./pages/MeusPlanos";
import { Documentos } from "./pages/ListarDocumentos";
import {
	Chart,
	CategoryScale,
	LinearScale,
	ArcElement,
	BarElement,
	Title,
	Tooltip,
	Legend,
} from "chart.js";
import { ResumoPagamentos } from "./pages/ResumoPagamentos";
import { Vincular } from "./pages/Vincular";
import { Quarentena } from "./pages/Quarentena";
import api from "./services/api";
import { Responsaveis } from "./pages/ListarResponsaveis";
import { ResponsavelCadastrar } from "./pages/CadastrarResponsavel";
import { ResponsavelEditar } from "./pages/EditarResponsavel";
import { AsoRegistro } from "./pages/Aso/Registro";
import { AsoRegistroValidarInfo } from "./pages/Aso/RegistroValidarInfo";
import AsoRegistroValidarEmail from "./pages/Aso/RegistroValidarEmail";
import { AsoRegistroValidaTokenEmail } from "./pages/Aso/RegistroValidaTokenEmail";
import { CadastrarConograma } from "./pages/CadastrarCronograma";
import AsoRegistroValidarIdentidade from "./pages/Aso/RegistroValidarIdentidade";
import { AsoTermosCondicoes } from "./pages/Aso/TermosCondicoes";
import AsoRegistroValidarTelefone from "./pages/Aso/RegistroValidarTelefone";
import AsoRegistroDisparaSms from "./pages/Aso/RegistroDIsparaSms";
import AsoRegistroValidarSmsToken from "./pages/Aso/RegistroDisparaSmsToken";
import AsoRegistroValidarSenha from "./pages/Aso/Registro/RegistroValidarSenha";
import { Representantes } from "./pages/ListarRepresentanteDeVendas";
import { RepresentanteDeVendasCadastrar } from "./pages/CadastrarRepresentanteDeVendas";
import { Comissoes } from "./pages/EditarComissoes";
import AsoRegistroValidarInfoEmpresa from "./pages/Aso/RegistroValidarInfoEmpresa";
import RegistroContinuarEmpresa from "./pages/Aso/RegistroContinuarEmpresa";
import AsoRegistroValidarCnpj from "./pages/Aso/RegistroValidarCnpj";
import AsoRegistroFaturamentoMensalEmpresa from "./pages/Aso/RegistroFaturamentoMensalEmpresa";
import AsoRegistroBeneficiariosFinais from "./pages/Aso/RegistroEmpresaBeneficiariosFinais";
import AsoRegistroFuncaoEmpresa from "./pages/Aso/RegistroFuncaoEmpresa";
import AsoRegistroValidarDocumentosEmpresa from "./pages/Aso/RegistroValidarDocumentosEmpresa";
import { RepresentanteDeVendasEditar } from "./pages/EditarRepresentanteDeVendas";
import AsoRegistroValidarIdentidadeEmpresa from "./pages/Aso/RegistroValidarIdentidadeEmpresa";
import { CadastroProvider } from "./contexts/CadastroContext";
import Teste from "./pages/Teste";
import { ComparacaoFacial } from "./pages/Aso/ComparacaoFacial";
import AvisoReconhecimentoFacial from "./pages/Aso/AvisoReconhecimentoFacial";
import { VincularExames } from "./pages/VincularExames";
import AsoRegistroEnderecoEmpresa from "./pages/Aso/RegistroEnderecoEmpresa";
import AsoRegistroCnae from "./pages/Aso/RegistroCNAE";
import AsoRegistroRazaoSocial from "./pages/Aso/RegistroRazaoSocial";
import AsoRegistroSelecionarResponsavel from "./pages/Aso/RegistroSelecionarResponsavel";
import { ResumoComissoes } from "./pages/ResumoComissoes";
import { ResumoVendasCredenciados } from "./pages/ResumoVendasCredenciados";
import { ResumoComissoesCredenciados } from "./pages/ResumoComissoesCredenciados";
import AsoRegistroValidarInfoNome from "./pages/Aso/RegistroValidarInfoNome";
import { TabelasDinamicas } from "./pages/TabelasDinamicas";
import { VincularTabelas } from "./pages/VincularTabelas";
import AsosAssinados from "./pages/AsosAssinados";
import AsoDocumentoAssinadoSucesso from "./pages/Aso/DocumentoAssinadoSucesso";
import AsoDocumentoAssinado from "./pages/Aso/DocumentoAssinado";
import { Credenciados } from "./pages/ListarCredenciados";
import { CredenciadosCadastrar } from "./pages/CadastrarCredenciado";
import { CredenciadosEditar } from "./pages/EditarCredenciado";
import { ResumoVendasRepresentantes } from "./pages/ResumoVendasRepresentantes";
import VerificarCadastroEmpresa from "./pages/Aso/VerificarCadastroEmpresa";
import ReaproveitamentoAso from "./pages/ListarReaproveitamentoAso";
import ReaproveitamentoAsoCadastrar from "./pages/CadastrarReaproveitamentoAso";
import RecuperarSenha from "./pages/RecuperarSenha";
import RedefinirSenha from "./pages/RedefinirSenha";
import { CuponsCadastrar } from "./pages/CadastrarCupom";
import { Cupons } from "./pages/ListarCupons";
import { TabelaBalcao } from "./pages/TabelaBalcao";
import ReaproveitarAsos from "./pages/ReaproveitarAsos";
import { ReaproveitamentoAdm } from "./pages/ReaproveitamentoAdm";
import { EditarReaproveitamentoAdm } from "./pages/EditarReaproveitamentoAdm";
import ReconhecimentoFacialAso from "./pages/Aso/ReconhecimentoFacialAso";
import { EditarReaproveitamentoEmpresaAdm } from "./pages/EditarReaproveitamentoEmpresaAdm";
import { TrabalhadoresCadastrar } from "./pages/CadastrarTrabalhador";
import { Trabalhadores } from "./pages/ListarTrabalhadores";
import { TrabalhadorEditar } from "./pages/EditarTrabalhador";
import { AsoRegistroValidarInfoReaproveitamento } from "./pages/Aso/AsoRegistroValidarInfoReaproveitamento";
import CadastrarPCMSO from "./pages/CadastrarPCMSO";
import { AsoPagamentoTrabalhador } from "./pages/Aso/AsoPagamentoTrabalhador";
import EditarPcmsoAdm from "./pages/CadastrarPCMSO/EditarPCMSOAdm";
import InformacoesTrabalhadorAso from "./pages/Aso/InformacoesTrabalhador";
import { InformacoesDocumentos } from "./pages/Aso/InfomacoesDocumento";
import AssinaturaReaproveitamentoAso from "./components/Aso/AssinaturaReaproveitamentoAso";
import AsoValidarInfoReap from "./components/Aso/Register/AsoValidarInfoReap";
import CadastroTrabalhador from "./components/CadastroTrabalhador";
import {AsoRegistroValidarInfoTrabalhadorExistente} from "./pages/Aso/RegistroValidarInfoTrabalhadorExistente";

Chart.register(
	ArcElement,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
);

export default function App() {
	const [_, setTokenValid] = useState(false);
	const navigate = useNavigate();
	const currentLocation = useLocation();

	// useEffect(() => {
	//   setTimeout(() => {
	//     driverService.start();
	//   }, 1000);
	// }, []);

	useEffect(() => {
		const validateToken = async () => {
			try {
				const token = localStorage.getItem("token");

				const dynamicPaths = [
					/^\/informacoes-documento-empresa\/\d+\/trabalhador\/\d+\/doc\/\d+$/,
					/^\/redefinir-senha\/.+$/,
				];

				const validPaths = [
					"/new-register",
					"/aso/registro",
					"/recuperar-senha",
					"/cadastro-trabalhador",
					"/login/cadastro-realizado-reaproveitamento",
				];

				const isValidPath =
					validPaths.includes(currentLocation.pathname) ||
					dynamicPaths.some((regex) => regex.test(currentLocation.pathname));

				if (isValidPath) {
					setTokenValid(true);
					return;
				}

				if (currentLocation.pathname.includes("aso")) {
					setTokenValid(true);
					return;
				}

				if (!token) {
					setTokenValid(false);
					navigate("/");
					return;
				}

				const response = await api.get("validate-token");

				if (response.data.isValid) {
					setTokenValid(true);
				} else {
					setTokenValid(false);
					navigate("/");
				}
			} catch (error) {
				console.error("Error validating token", error);
				setTokenValid(false);
				navigate("/");
			}
		};

		validateToken();
	}, [navigate]);

	return (
		<>
			<CadastroProvider>
				<Routes>
					<Route path="/teste" element={<Teste />} />
					<Route path="/" element={<Login />} />
					<Route
						path="/login/reaproveitamento-de-aso/:email"
						element={<Login />}
					/>
					<Route
						path="/login/cadastro-realizado-reaproveitamento"
						element={<Login />}
					/>
					<Route path="/new-register" element={<NewRegister />} />
					<Route path="/recuperar-senha" element={<RecuperarSenha />} />
					<Route path="/redefinir-senha/:token" element={<RedefinirSenha />} />
					<Route path="/home" element={<Home />} />
					<Route path="/quarentena" element={<Quarentena />} />
					<Route path="/funcionarios" element={<Funcionarios />} />
					<Route path="/trabalhadores" element={<Trabalhadores />} />
					<Route
						path="/trabalhadores/cadastrar"
						element={<TrabalhadoresCadastrar />}
					/>
					<Route
						path="/trabalhadores/editar/:idTrabalhador"
						element={<TrabalhadorEditar />}
					/>
					<Route
						path="/funcionarios/cadastrar/:idEmpresa"
						element={<FuncionariosCadastrar />}
					/>
					<Route
						path="/funcionarios/editar/:idFuncionario"
						element={<FuncionariosEditar />}
					/>
					<Route path="/empresas" element={<Empresas />} />
					<Route path="/empresas/cadastrar" element={<EmpresasCadastrar />} />
					<Route
						path="/empresas/editar/:idEmpresa"
						element={<EmpresasEditar />}
					/>
					<Route path="/produtos" element={<Produtos />} />
					<Route path="/cupons/cadastrar" element={<CuponsCadastrar />} />
					<Route path="/cupons" element={<Cupons />} />
					<Route path="/produtos/cadastrar" element={<ProdutosCadastrar />} />
					<Route
						path="/produtos/editar/:idProduto"
						element={<ProdutosEditar />}
					/>
					<Route path="/pgr" element={<MeuPGR />} />
					<Route path="/asos-assinados" element={<AsosAssinados />} />
					<Route
						path="/pgr/:empresaId/:fdtId/:revisaoId"
						element={<MeuPGR />}
					/>
					<Route path="/pcmso" element={<MeuPGR />} />
					<Route
						path="/pcmso/:empresaId/:fdtId/:revisaoId"
						element={<MeuPGR />}
					/>
					<Route
						path="/pgr/editar-risco/:idEmpresa/:idRisco"
						element={<PgrRiscoEditar />}
					/>
					<Route path="/planos" element={<SelecionarPlanos />} />
					<Route path="/planos-ativos" element={<MeusPlanos />} />
					<Route path="/pagamentos" element={<Pagamentos />} />
					<Route path="/documentos" element={<Documentos />} />
					<Route path="/resumo-pagamentos" element={<ResumoPagamentos />} />
					<Route path="/resumo-comissoes" element={<ResumoComissoes />} />
					<Route path="/vincular-riscos" element={<Vincular />} />
					<Route path="/vincular-exames" element={<VincularExames />} />
					<Route path="/vincular-tabelas" element={<VincularTabelas />} />
					<Route path="/representantes" element={<Representantes />} />
					<Route
						path="/representantes/cadastrar"
						element={<RepresentanteDeVendasCadastrar />}
					/>
					<Route
						path="/representantes/editar/:idRepresentante"
						element={<RepresentanteDeVendasEditar />}
					/>
					<Route
						path="/vendas-credenciado"
						element={<ResumoVendasCredenciados />}
					/>
					<Route
						path="/comissoes-credenciado"
						element={<ResumoComissoesCredenciados />}
					/>
					<Route path="/responsaveis" element={<Responsaveis />} />
					<Route
						path="/responsaveis/cadastrar"
						element={<ResponsavelCadastrar />}
					/>
					<Route
						path="/responsaveis/editar/:idResponsavel"
						element={<ResponsavelEditar />}
					/>
					<Route path="/cronograma" element={<CadastrarConograma />} />
					<Route path="/tabelas-dinamicas" element={<TabelasDinamicas />} />
					<Route path="/tabela-balcao" element={<TabelaBalcao />} />
					<Route path="/comissoes" element={<Comissoes />} />
					<Route path="/credenciados" element={<Credenciados />} />
					<Route
						path="/credenciados/cadastrar"
						element={<CredenciadosCadastrar />}
					/>
					<Route
						path="/credenciados/editar/:id"
						element={<CredenciadosEditar />}
					/>
					<Route
						path="/vendas-realizadas"
						element={<ResumoVendasRepresentantes />}
					/>
					<Route
						path="/reaproveitamento-aso/cadastrar"
						element={<ReaproveitamentoAsoCadastrar />}
					/>
					<Route
						path="/reaproveitamento-aso/aso-pcmso"
						element={<CadastrarPCMSO />}
					/>
					<Route
						path="/reaproveitamento-aso/editar-pcmso/:idReapPcmso"
						element={<EditarPcmsoAdm />}
					/>
					<Route
						path="/reaproveitamento-aso"
						element={<ReaproveitamentoAso />}
					/>
					<Route path="/reaproveitar-asos" element={<ReaproveitarAsos />} />
					<Route path="/reaproveitamentos" element={<ReaproveitamentoAdm />} />
					<Route
						path="/reaproveitamentos/editar-trabalhador/:indexAso"
						element={<EditarReaproveitamentoAdm />}
					/>
					<Route
						path="/reaproveitamentos/editar-empresa/:indexAso"
						element={<EditarReaproveitamentoEmpresaAdm />}
					/>
					<Route
						path="/aso/pagamento-trabalhador/:trabalhadorId/:funcaoId"
						element={<AsoPagamentoTrabalhador />}
					/>
					<Route path="/aso/registro" element={<AsoRegistro />} />
					<Route path="/aso/registro/:idParam" element={<AsoRegistro />} />
					<Route
						path="/aso/registro/validar-info/:idConsulta/:dbName"
						element={<AsoRegistroValidarInfo />}
					/>
					<Route
						path="/aso/registro/validar-info-trabalhador-existente/:idConsulta"
						element={<AsoRegistroValidarInfoTrabalhadorExistente />}
					/>
					<Route
						path="/aso/registro/validar-info-reaproveitamento/:idConsulta"
						element={<AsoRegistroValidarInfoReaproveitamento />}
					/>
					<Route
						path="/aso/registro/continuar"
						element={<RegistroContinuarEmpresa />}
					/>
					<Route
						path="/aso/registro/verifica-empresa-cadastrada"
						element={<VerificarCadastroEmpresa />}
					/>
					<Route
						path="/aso/registro/validar-info-empresa/:idConsulta?"
						element={<AsoRegistroValidarInfoEmpresa />}
					/>
					<Route
						path="/aso/registro/validar-email/:dbName"
						element={<AsoRegistroValidarEmail />}
					/>
					<Route
						path="/aso/registro/validar-email-token/:dbName"
						element={<AsoRegistroValidaTokenEmail />}
					/>
					/*fluxo de registro no aso sem o nr da consulta*/
					<Route
						path="/aso/registro/validar-info-aso/:dbName"
						element={<AsoRegistroValidarInfo />}
					/>
					<Route
						path="/aso/registro/validar-email-aso/:dbName"
						element={<AsoRegistroValidarEmail />}
					/>
					<Route
						path="/aso/registro/validar-email-token-aso/:dbName"
						element={<AsoRegistroValidaTokenEmail />}
					/>
					<Route
						path="/aso/registro/validar-nome-aso/:dbName"
						element={<AsoRegistroValidarInfoNome />}
					/>
					<Route
						path="/aso/registro/validar-identidade-aso/:dbName"
						element={<AsoRegistroValidarIdentidade />}
					/>
					<Route
						path="/aso/registro/validar-telefone-aso/:dbName"
						element={<AsoRegistroValidarTelefone />}
					/>
					<Route
						path="/aso/registro/disparo-sms-aso/:dbName"
						element={<AsoRegistroDisparaSms />}
					/>
					<Route
						path="/aso/registro/disparo-sms-token-aso/:telefoneInput/:dbName"
						element={<AsoRegistroValidarSmsToken />}
					/>
					<Route
						path="/aso/registro/validar-senha-aso/:dbName"
						element={<AsoRegistroValidarSenha />}
					/>
					<Route
						path="/aso/registro/aviso-reconhecimento-facial-aso/:dbName/:id"
						element={<AvisoReconhecimentoFacial />}
					/>
					<Route
						path="/aso/registro/reconhecimento-facial-aso2/:dbName/:id?"
						element={<ComparacaoFacial />}
					/>
					<Route
						path="/aso/registro/validar-cnpj"
						element={<AsoRegistroValidarCnpj />}
					/>
					<Route
						path="/aso/registro/razao-social"
						element={<AsoRegistroRazaoSocial />}
					/>
					<Route path="/aso/registro/cnae" element={<AsoRegistroCnae />} />
					<Route
						path="/aso/registro/endereco-empresa"
						element={<AsoRegistroEnderecoEmpresa />}
					/>
					<Route
						path="/aso/registro/faturamento-mensal-empresa"
						element={<AsoRegistroFaturamentoMensalEmpresa />}
					/>
					<Route
						path="/aso/registro/empresa-beneficiarios-finais"
						element={<AsoRegistroBeneficiariosFinais />}
					/>
					<Route
						path="/aso/registro/validar-documentos-empresa"
						element={<AsoRegistroValidarDocumentosEmpresa />}
					/>
					<Route
						path="/aso/registro/selecionar-responsavel"
						element={<AsoRegistroSelecionarResponsavel />}
					/>
					<Route
						path="/aso/registro/validar-identidade-empresa"
						element={<AsoRegistroValidarIdentidadeEmpresa />}
					/>
					<Route
						path="/aso/registro/funcao-empresa"
						element={<AsoRegistroFuncaoEmpresa />}
					/>
					<Route
						path="/aso/registro/validar-identidade/:dbName"
						element={<AsoRegistroValidarIdentidade />}
					/>
					<Route
						path="/aso/registro/validar-nome/:dbName"
						element={<AsoRegistroValidarInfoNome />}
					/>
					<Route
						path="/aso/registro/validar-telefone/:dbName"
						element={<AsoRegistroValidarTelefone />}
					/>
					<Route
						path="/aso/registro/disparo-sms/:dbName"
						element={<AsoRegistroDisparaSms />}
					/>
					<Route
						path="/aso/registro/disparo-sms-token/:telefoneInput/:dbName"
						element={<AsoRegistroValidarSmsToken />}
					/>
					<Route
						path="/aso/registro/validar-senha/:dbName"
						element={<AsoRegistroValidarSenha />}
					/>
					<Route path="/aso/registro/termos" element={<AsoTermosCondicoes />} />
					<Route
						path="/aso/registro/aviso-reconhecimento-facial/:dbName/:id"
						element={<AvisoReconhecimentoFacial />}
					/>
					<Route
						path="/aso/registro/reconhecimento-facial/:idConsulta/:dbName/:id?"
						element={<ComparacaoFacial />}
					/>
					<Route
						path="/aso/registro/reconhecimento-facial-aso/:idConsulta/:dbName"
						element={<ReconhecimentoFacialAso />}
					/>
					<Route
						path="/cadastro-trabalhador"
						element={<CadastroTrabalhador />}
					/>
					<Route
						path="/aso/reaproveitamento/assinatura-facial/:idConsulta/:dbName?"
						element={<AssinaturaReaproveitamentoAso />}
					/>
					<Route
						path="/aso/reaproveitamento/validar-informacoes/:idConsulta/:dbName?"
						element={<AsoValidarInfoReap />}
					/>
					{/* <Route path="/aso/registro/reconhecimento-facial" element={<ComparacaoFacial />} /> */}
					<Route
						path="/aso/registro/documento-assinado-sucesso"
						element={<AsoDocumentoAssinadoSucesso />}
					/>
					<Route
						path="/aso/registro/documento-assinado"
						element={<AsoDocumentoAssinado />}
					/>
					<Route
						path="/aso/registro/aviso-recinhecimento-facial/:dbName"
						element={<AvisoReconhecimentoFacial />}
					/>
					<Route
						path="/aso/registro/informacoes-trabalhador"
						element={<InformacoesTrabalhadorAso />}
					/>
					<Route
						path="/informacoes-documento-empresa/:idEmpresa/trabalhador/:idTrabalhador/doc/:idDoc"
						element={<InformacoesDocumentos />}
					/>
					<Route path="/*" element={<Navigate to="/" />} />
				</Routes>
			</CadastroProvider>
		</>
	);
}
